var sessionStorageKey = 'activeFormId';
var ReloadHandler = /** @class */ (function () {
    function ReloadHandler(props) {
        this.id = undefined;
        this.wrapper = undefined;
        this.triggers = undefined;
        this.focusTarget = undefined;
        var id = props.id, wrapper = props.wrapper, triggers = props.triggers, focusTarget = props.focusTarget;
        this.id = id;
        this.wrapper = wrapper;
        this.focusTarget = focusTarget;
        this.triggers = triggers || this.wrapper.querySelectorAll('[type="submit"]');
        this.init();
    }
    ReloadHandler.prototype.scrollAndFocus = function () {
        if (this.focusTarget) {
            this.focusTarget.setAttribute('tabIndex', '-1');
            this.focusTarget.focus();
        }
    };
    ReloadHandler.prototype.init = function () {
        if (document.getElementById(this.id)) {
            if (sessionStorage.getItem(sessionStorageKey)) {
                sessionStorage.removeItem(sessionStorageKey);
                this.scrollAndFocus();
            }
            var triggers = Array.from(this.triggers);
            triggers.forEach(function (trigger) {
                var type = trigger.nodeName == "FORM" ? "submit" : "click";
                trigger.addEventListener(type, function (event) {
                    window.sessionStorage.setItem(sessionStorageKey, 'true');
                });
            });
        }
    };
    return ReloadHandler;
}());
export { ReloadHandler };
export default ReloadHandler;
